import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-accordion',
    templateUrl: './custom-accordion.component.html',
    styleUrls: ['./custom-accordion.component.scss'],
    standalone: false
})
export class CustomAccordionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
